import { axiosInstance } from "./axiosInstance";

export const getAdminBanners = async (bannerType?: string) => {
    try {
        const params = bannerType ? { bannerType } : {};
        const response = await axiosInstance.get(`/api/admin/banners`, { params });
        return response.data;
    } catch (error) {
        console.error("배너 목록 조회 에러:", error);
        throw error;
    }
};

export const getAdminBannerDetail = async (bannerId: string | number) => {
    try {
        const response = await axiosInstance.get(`/api/admin/banners/${bannerId}`);
        return response.data;
    } catch (error) {
        console.error("배너 상세 조회 에러:", error);
        throw error;
    }
};

export const createAdminBanner = async (data: any) => {
    try {
        const response = await axiosInstance.post(`/api/admin/banners`, data);
        return response.data;
    } catch (error) {
        console.error("배너 생성 에러:", error);
        throw error;
    }
};

export const updateAdminBanner = async (bannerId: string | number, data: any) => {
    try {
        const response = await axiosInstance.put(`/api/admin/banners/${bannerId}`, data);
        return response.data;
    } catch (error) {
        console.error("배너 수정 에러:", error);
        throw error;
    }
};

export const deleteAdminBanner = async (bannerId: string | number) => {
    try {
        const response = await axiosInstance.delete(`/api/admin/banners/${bannerId}`);
        return response.data;
    } catch (error) {
        console.error("배너 삭제 에러:", error);
        throw error;
    }
};